import { cn } from '@scatterlab/zeta-core';
import { createElement, FC, memo } from 'react';
import { match } from 'ts-pattern';

import {
  RankingNum1Icon,
  RankingNum2Icon,
  RankingNum3Icon,
  RankingNum4Icon,
  RankingNum5Icon,
  RankingNum6Icon,
  RankingNum7Icon,
  RankingNum8Icon,
  RankingNum9Icon,
  RankingNum10Icon,
} from '../icons';

interface RankingNumProps {
  rank: number;
  className?: string;
}

const OtherwiseRankingNum = () => null;

const RankingNum: FC<RankingNumProps> = ({ rank, className }) =>
  createElement(
    match(rank)
      .with(1, () => RankingNum1Icon)
      .with(2, () => RankingNum2Icon)
      .with(3, () => RankingNum3Icon)
      .with(4, () => RankingNum4Icon)
      .with(5, () => RankingNum5Icon)
      .with(6, () => RankingNum6Icon)
      .with(7, () => RankingNum7Icon)
      .with(8, () => RankingNum8Icon)
      .with(9, () => RankingNum9Icon)
      .with(10, () => RankingNum10Icon)
      .otherwise(() => OtherwiseRankingNum),
    { className: cn('text-gray-400', className) },
  );

export default memo(RankingNum) as typeof RankingNum;
